import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  SET_STATUS,
  RESET_STATUS,
  SET_ERROR,
  FETCH_SETTINGS_SUCCESS,
  FETCH_USERS_SUCCESS,
  SET_UPDATE_LOADING,
  SET_ACTIONS_LOADING,
  FETCH_ACTIONS_SUCCESS,
  TOGGLE_CORPORATE_SUCCESS,
  DELETE_USER_SUCCESS,
  DUPLICATE_USER_SUCCESS,
  EDIT_USER_SUCCESS,
  FETCH_USER_INFO_SUCCESS,
  MIRROR_USER_SUCCESS
} from "./usersSagas";
import sortBy from "lodash/sortBy";

export const initialState = {
  isLoading: true,
  areUsersLoading: false,
  actionsLoading: true,
  status: "idle",
  errors: null,
  users: null,
  commonSettings: { roles: [], locations: [], permissions: [] },
  currentUserInfo: null,
  currentUserActions: {},
  currentSearchParam: null
};

export default handleActions(
  {
    [SET_ERROR]: (state, action) => ({
      ...state,
      status: "failed",
      errors: action.payload
    }),
    [SET_STATUS]: (state, action) => ({
      ...state,
      status: action.payload
    }),
    [RESET_STATUS]: (state) => ({
      ...state,
      status: "idle",
      errors: null,
      currentUserInfo: null
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATE_LOADING]: (state, action) => ({
      ...state,
      areUsersLoading: action.payload
    }),
    [SET_ACTIONS_LOADING]: (state, action) => ({
      ...state,
      actionsLoading: action.payload
    }),
    [FETCH_SETTINGS_SUCCESS]: (state, action) => ({
      ...state,
      commonSettings: action.payload
    }),
    [FETCH_USERS_SUCCESS]: (state, { payload: { users, searchParam } }) => ({
      ...state,
      users,
      currentSearchParam: searchParam ? searchParam : state.currentSearchParam
    }),
    [FETCH_ACTIONS_SUCCESS]: (state, action) => ({
      ...state,
      currentUserActions: action.payload
    }),
    [FETCH_USER_INFO_SUCCESS]: (state, action) => ({
      ...state,
      currentUserInfo: action.payload
    }),
    [TOGGLE_CORPORATE_SUCCESS]: (state, { payload: { id, isCorporate } }) => ({
      ...state,
      users: state.users.map((user) =>
        user.id == id ? { ...user, isCorporate: !isCorporate } : user
      )
    }),
    [DUPLICATE_USER_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        users: sortByName([...state.users, payload])
      };
    },
    [EDIT_USER_SUCCESS]: (state, { payload: { id, data, haveNamesChanged } }) => {
      const users = state.users.map((user) => (user.id == id ? data : user));
      return {
        ...state,
        status: "success",
        users: haveNamesChanged ? sortByName(users) : users
      };
    },
    [MIRROR_USER_SUCCESS]: (state, { payload: { data } }) => {
      return {
        ...state,
        users: state.users.map((user) => {
          let foundUser = data.find((val) => val.id === user.id);

          return foundUser ? foundUser : user;
        })
      };
    },
    [DELETE_USER_SUCCESS]: (state, { payload: { id } }) => ({
      ...state,
      users: state.users.filter((user) => user.id !== id)
    })
  },

  initialState
);

const sortByName = (arr) => {
  return sortBy(arr, [
    (user) => user.lastName.toLowerCase(),
    (user) => user.firstName.toLowerCase()
  ]);
};
